"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDateComponentParameters = exports.YEAR_RANGE_VALIDATOR = exports.YEAR_SELECT_RENDERER = void 0;
/** Form renderer to pick or type a 4 digit year, saved as an integer. The list uses the `minYear` and `maxYear` extra props. */
exports.YEAR_SELECT_RENDERER = 'year-select';
/** Name of the form validator that checks Start Year is not after End Year. */
exports.YEAR_RANGE_VALIDATOR = 'yearRangeValidator';
exports.UserDateComponentParameters = [
    {
        id: 'startRange',
        label: 'Start Year',
        description: 'Input Param - The earliest year the worker can select (e.g. 2004). Must not be after the End Year',
        // The form shows a year list that also accepts a typed year. The saved value is an integer year, which is what the Android app expects.
        type: 'int',
        renderer: exports.YEAR_SELECT_RENDERER,
        validator: exports.YEAR_RANGE_VALIDATOR,
        required: false,
        paramType: 'INT',
    },
    {
        id: 'endRange',
        label: 'End Year',
        description: 'Input Param - The latest year the worker can select (e.g. 2025). Must not be before the Start Year',
        type: 'int',
        renderer: exports.YEAR_SELECT_RENDERER,
        validator: exports.YEAR_RANGE_VALIDATOR,
        required: false,
        paramType: 'INT',
    },
    {
        id: 'preFill',
        label: 'Pre-fill Value',
        description: 'Input Param - A pre-filled value for the date field',
        type: 'string',
        required: false,
        paramType: 'STRING',
    },
    {
        id: 'outputDate',
        label: 'Output Date',
        description: 'Output Param - The date value selected by the user',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
];
//# sourceMappingURL=UserDateComponent.js.map